import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class AiQuestion extends BasicEntity {
code: string;
keywords: Object;
language: string;
prompt: string;
visionCode: string;
}

